import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Order } from 'src/app/models/order';
import { OrderService } from 'src/app/services/order.service';
import { AuthService } from 'src/app/services/auth.service';
import { TravelService } from 'src/app/services/travel.service';
import { Travel } from 'src/app/models/travel';
import { ToastrManager } from 'ng6-toastr-notifications';
import { LogisticEventsService } from 'src/app/services/logistic-events.service';

@Component({
  selector: 'app-order-single',
  templateUrl: './order-single.component.html',
  styleUrls: ['./order-single.component.css']
})
export class OrderSingleComponent implements OnInit {

  loading:boolean = false;
  order:Order = new Order();
  travel:Travel = new Travel();

  canGetTravel:boolean = false;
  canEdit:boolean = false;
  canDelete:boolean = false;

  constructor(actRoute:ActivatedRoute, private orderServ:OrderService, private authService:AuthService, private traServ:TravelService, private toastr:ToastrManager, private logisticEv:LogisticEventsService) {
    
    actRoute.params.subscribe(params => {
      this.order.id = params.id;
      this.loadOrder(params.id);
    });
  }
  
  loadOrder(id){
    this.loading = true;
    this.orderServ.getOrder(id).then(order => {
      this.order = order;
      this.loading = false;
      
      this.canDelete = this.authService.can('destroy-order');
      this.canEdit = this.authService.can('update-order') && order.status == 'Creada';
      if (this.authService.can('get-travels') && order.status != 'Creada' && order.status != 'Cancelado') {
        this.traServ.getTravelByOrder(order).then(travel => {
          this.canGetTravel = true;
          this.travel = travel;
        });
      }
    });
  }

  deleteOrder(){
    this.orderServ.deleteOrder(this.order)
      .then(resp => {
        this.order.status = 'Cancelado';
        this.toastr.successToastr("Orden eliminada correctamente!");
        this.logisticEv.sendOrderDeleted(this.order);
      }).catch(resp => {
        if (resp.error.message) {
          this.toastr.errorToastr(resp.error.message);
        } else {
          this.toastr.errorToastr('Error al eliminar orden');
        }
      });
  }

  ngOnInit() {
  }

}
